import { system } from '../../core/dist/index.esm.js';
var shadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});
export { shadow as default, shadow };